'use strict';

/**
 * Created by Andreas on 30/04/16.
 */
import $ from 'jquery';
import Widgets from 'js-widget-hooks';
import app from '../components/app';

Widgets.register('citySort', function (el) {

    const elem = $(el);
    const letters = elem.find('.letter-list-wrapper');

    elem.find('.filter-letter').click(function(e){

        e.preventDefault();

        let el = $(this);
        letters.hide();

        $(el.attr('href')).show();
    });

    elem.find('.center-line').click(function(e){
        e.stopPropagation();
        e.preventDefault();

        var el = $(this),
            slug = el.data('centerslug')
            ;

        app.setState({'current_center' : slug, 'external_center_change': slug });
    });

    elem.find('.center-line a').click(function(e){
        e.preventDefault();
    });
});